'use client'

/* eslint-disable react/react-in-jsx-scope */
import { Link, 
  // useNavigate, 
} from "react-router"
import { useState } from 'react'
import axios from 'axios';
// import { useAuth } from "./AuthProvider";
import { enCrypt, deCrypt, aesEncrypt, aesDecrypt } from "../api/enCrypt";

function Register() {

  const [pwdMatch, setpwdMatch] = useState(true);
  const [Pwd, setPwd] = useState('');
  const [checkPwd, setcheckPwd] = useState('');
  const [resMessage, setresMessage] = useState("");
  // const auth = useAuth();
// const navigate = useNavigate();

  const [input, setInput] = useState({
    email: "",
    name: "",
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));

    // console.log(input);
  };


  const handlePwd = (e) => {
    setPwd(e.target.value);
    // console.log(Pwd)

  };

  const handleChackPwd = (e) => {
    setcheckPwd(e.target.value);
    // console.log(checkPwd,e.target.name)
    if (e.target.name === "confirmPassword" && e.target.value === Pwd) {
      setpwdMatch(false);
      // console.log(checkPwd)
    } else 
    {
      setpwdMatch(true);
    }
  };

  // const encryptPwd =  ( )=> {

  //   if(!asd && valuesf.userPwd !== '') {
  //     setValuesf({
  //       ...valuesf,
  //       userPwd: enCrypt(valuesf.userPwd),
  //     });    

  //     setAsd(true)

  //     } else {
  //       setAsd(false)
  //     }


  const handleSubmitEvent = async (e) => {
    e.preventDefault();
    setresMessage("");

    let p = input.email + Pwd;
    // console.log(p);
    const token = aesEncrypt(p);
    // console.log(token);

    const formData = {
      "email": input.email,
      "name": input.name,
      "password": token ,
      "Avatar" : "user.png",
      "Role" : "Customer",
      "isAdmin" : "0",
      "actived" : "0",
      "mode": 'add',
    }

  //   console.log(data);

  //   // const formData = new FormData();

  //   for (const key in data) {
  //     if (data.hasOwnProperty(key)) {
  //       formData.append(key, data[key]);
  //   }
  // }

    //  console.log(JSON.stringify(formData));

    // auth.registerAction({
    //   email: input.email,
    //   name: input.name,
    //   password: Pwd ,
    // });
    // var  formData = new FormData();
    // formData.append('email',input.email);
    // formData.append('name',input.name);
    // formData.append('password',Pwd);

    // for (const [key, value] of formData.entries()) {
    //   console.log(`${key}: ${value}`);
    // }
    
    // console.log(JSON.stringify(data));
    
    // navigate(`/pos`);
      try {
        const res = await axios({
                  method: 'post',
                  url: `${process.env.REACT_APP_API}/users.php`,
                  headers: {
                      'Accept': 'application/json',
                      // 'Content-type': 'application/x-www-form-urlencoded',
                      // 'Content-type': 'application/json; charset=utf-8',
                      'Content-Type': 'multipart/form-data'
                  },
                  data: JSON.stringify(formData) ,
              });

              // console.log(res);
              if(res.status===200) {
                // console.log("OK")
                // setresMessage("Register Success.");
                setresMessage("Saved.");
                setPwd("");
                setcheckPwd("");
                setpwdMatch(true);
                setInput(() => ({
                  email: "",
                  name: "",
                }));

              }

      } catch (error) {
        console.error("Error fetching users:", error);
        setresMessage("Error!!!");
      }
      
    }

  // console.log(Pwd)
  return (
    <div className="flex w-full min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8 bg-slate-900">
      <div className="mx-auto w-40 md:w-56  max-w-sm">
        <Link to="/">
            <img
                alt="Molthana Bakery&Chiffon"
                src="/logo.jpg"
                className="mx-auto w-full rounded-2xl"
            />
        </Link>
      </div>
      <div className="mt-6 w-full text-center text-2xl/9 font-bold tracking-tight text-gray-300">
      <h2 >
          Register to your account
      </h2>
      {/* <p className="text-md text-blue-400">{setresMessage}</p> */}

      </div>
        <div className="mt-10 mx-auto w-full max-w-sm">
          <form id="Register" className="space-y-6" action="#" onSubmit={handleSubmitEvent}>
            <div>
              <label htmlFor="email" className="block text-sm/6 font-medium text-gray-400">
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  onChange={handleInput}
                  value={input.email}
                  required
                  autoComplete="email"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-600 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
            <div>
              <label htmlFor="email" className="block text-sm/6 font-medium text-gray-400">
                User Name
              </label>
              <div className="mt-2">
                <input
                  id="name"
                  name="name"
                  type="text"
                  onChange={handleInput}
                  value={input.name}
                  required
                  autoComplete="null"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-600 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-400">
                  Password
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  onChange={handlePwd}
                  value={Pwd}
                  required
                  autoComplete="null"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-600 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-400">
                  Confirm Password
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  onChange={handleChackPwd}
                  value={checkPwd}
                  required
                  autoComplete="null"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-600 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>

            <div>
              <input type="hidden" id="mode" name="mode" value="add" />
              <button
                type="submit"
                // onClick={handleSubmitEvent}
                disabled={pwdMatch}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Register
              </button>
            </div>
          </form>
          <p className="mt-2 text-center text-sm/6 text-gray-400">{resMessage}</p>
          <p className="mt-6 text-center text-sm/6 text-gray-400">
            Have Account?{' '}
            <Link to="/login" className="font-semibold text-indigo-400 hover:text-indigo-500">
              Sign in
            </Link>
          </p>
        </div>
      </div>
  )
}

export default Register